/**
 * BlockRenderer — displays story blocks in magazine-style layout.
 * Used in StoryDetail to render the `blocks` array from the API.
 */
export default function BlockRenderer({ blocks, legacyContent }) {
  // If there are structured blocks, render them
  if (blocks && blocks.length > 0) {
    return (
      <div className="article-body">
        {blocks.map((block, i) => <Block key={block.id || i} block={block} />)}
      </div>
    );
  }

  // Fall back to plain text content (legacy stories)
  if (legacyContent) {
    return (
      <div className="article-body">
        {legacyContent.split('\n\n').map((para, i) => (
          <p key={i}>{para}</p>
        ))}
      </div>
    );
  }

  return null;
}

function Block({ block }) {
  switch (block.type) {
    case 'paragraph':
      return block.content
        ? <p>{block.content}</p>
        : null;

    case 'heading':
      return block.content
        ? <h2>{block.content}</h2>
        : null;

    case 'subheading':
      return block.content
        ? <h3>{block.content}</h3>
        : null;

    case 'image':
      return block.image_url ? (
        <figure>
          <img src={block.image_url} alt={block.caption || ''} />
          {block.caption && <figcaption>{block.caption}</figcaption>}
        </figure>
      ) : null;

    case 'split_left':
      return (block.image_url || block.text) ? (
        <div className="split-block">
          {block.image_url && (
            <figure style={{ margin: 0 }}>
              <img src={block.image_url} alt={block.caption || ''} />
              {block.caption && <figcaption>{block.caption}</figcaption>}
            </figure>
          )}
          {block.text && (
            <div className="split-text">
              {block.text.split('\n\n').map((p, i) => <p key={i}>{p}</p>)}
            </div>
          )}
        </div>
      ) : null;

    case 'split_right':
      return (block.image_url || block.text) ? (
        <div className="split-block reverse">
          {block.image_url && (
            <figure style={{ margin: 0 }}>
              <img src={block.image_url} alt={block.caption || ''} />
              {block.caption && <figcaption>{block.caption}</figcaption>}
            </figure>
          )}
          {block.text && (
            <div className="split-text">
              {block.text.split('\n\n').map((p, i) => <p key={i}>{p}</p>)}
            </div>
          )}
        </div>
      ) : null;

    case 'quote':
      return block.content ? (
        <blockquote>
          {block.content}
          {block.attribution && (
            <span className="attribution">{block.attribution}</span>
          )}
        </blockquote>
      ) : null;

    case 'divider':
      return <hr />;

    default:
      return null;
  }
}
